import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, ViewEncapsulation } from '@angular/core';

interface ConfirmationDialogData {
  HEADER: string;
  DESC: string[];
  CLOSE_BTN?: string;
}

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ConfirmationComponent {
  constructor(
    @Inject(DIALOG_DATA) protected data: ConfirmationDialogData,
    public dialogRef: DialogRef<boolean>
  ) {}

  onClose() {
    this.dialogRef.close(false);
  }
}
